import { render, staticRenderFns } from "./houseCorrelationPerson.components.vue?vue&type=template&id=565aaab1&scoped=true"
import script from "./houseCorrelationPerson.components.vue?vue&type=script&lang=js"
export * from "./houseCorrelationPerson.components.vue?vue&type=script&lang=js"
import style0 from "./houseCorrelationPerson.components.vue?vue&type=style&index=0&id=565aaab1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565aaab1",
  null
  
)

export default component.exports